import { render, staticRenderFns } from "./match-controller-merge.vue?vue&type=template&id=b5c183f8&scoped=true"
import script from "./match-controller-merge.vue?vue&type=script&lang=js"
export * from "./match-controller-merge.vue?vue&type=script&lang=js"
import style0 from "./match-controller-merge.vue?vue&type=style&index=0&id=b5c183f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c183f8",
  null
  
)

export default component.exports